import type { MaterialItem } from "../types/study";

type StatementCardProps = {
  item: MaterialItem;
};

export function StatementCard({ item }: StatementCardProps) {
  return (
    <article className="statement-card">
      <p>{item.statement_text}</p>
    </article>
  );
}
